import { h } from '@stencil/core';
import { error } from '@/utils/utils';

export type LoginRequiredProps = {
  authenticationUrl: (provider?: string) => Promise<string>;
  authError?: string;
};

export const LoginRequired = ({ authenticationUrl, authError }: LoginRequiredProps) => (
  <div class={'login-required'} part="nse__login-required login-component">
    <div class={'card'} part="nse__login-required-card">
      {authError && (
        <div class="login-error-banner" part="nse__login-required-error" role="alert">
          <warning-icon width="16" height="16" />
          <span>{authError}</span>
        </div>
      )}
      <p part="nse__login-required-text">Log into your account to use the Scheduler Editor.</p>

      <button
        class="google-button"
        part="nse__login-required-google-button"
        onClick={async event => {
          event.preventDefault();
          const authUrl = await authenticationUrl('google');
          if (authUrl) {
            window.location.href = authUrl;
          } else {
            error(`[nylas-scheduler-editor] Unable to get authentication URL.`);
          }
        }}
      >
        <span class="icon">
          <google-logo-icon width="15" height="15" />
        </span>
        Continue with Google
      </button>

      <button
        class="microsoft-button"
        part="nse__login-required-microsoft-button"
        onClick={async event => {
          event.preventDefault();
          const authUrl = await authenticationUrl('microsoft');
          if (authUrl) {
            window.location.href = authUrl;
          } else {
            error(`[nylas-scheduler-editor] Unable to get authentication URL.`);
          }
        }}
      >
        <span class="icon">
          <microsoft-logo-icon width="15" height="15" />
        </span>
        Continue with Microsoft
      </button>

      <button
        class="other-provider-button"
        part="nse__login-required-other-provider-button"
        onClick={async event => {
          event.preventDefault();
          const authUrl = await authenticationUrl();
          if (authUrl) {
            window.location.href = authUrl;
          } else {
            error(`[nylas-scheduler-editor] Unable to get authentication URL.`);
          }
        }}
      >
        View all providers <chevron-icon width="17" height="17" />
      </button>

      <small class="disclaimer-text" part="nse__login-required-disclaimer-text">
        * You will be redirected to authenticate your account.
      </small>
    </div>
  </div>
);
